<template>
  <v-app>
    <div class="text-center mt-9" v-if="loading">
      <div class="text-center mt-9">
        <v-progress-circular indeterminate color="brown" size="80"></v-progress-circular>
      </div>
    </div>
    <div v-else>
      <component :is="view"></component>
    </div>
  </v-app>
</template>

<script>
import queryString from "query-string";
import Login from "./views/Login.vue";
export default {
  name: "App",

  components: { Login },

  data() {
    return { loading: true, query: "" };
  },
  mounted() {
    var vm = this;
    vm.queryinit();
    vm.init();
    document.title = "FET Vending Service";
  },
  methods: {
    init() {
      var vm = this;
      if (this.query.apptype == "line") {
        this.initializeLiff("1654153688-P68ROL8x");
      } else {
        window.extAsyncInit = function() {
          // the Messenger Extensions JS SDK is done loading
          vm.loading = false;
        };
      }
    },
    async initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      try {
        await this.$liff.init({
          liffId: myLiffId
        });
        if (await this.$liff.isLoggedIn()) {
          vm.$store.state.profile = await this.$liff.getProfile();
          vm.loading = false;
        } else {
          await this.$liff.login({ redirectUri });
        }
      } catch (error) {
        // alert(JSON.stringify(error));
      }
    },
    queryinit() {
      var vm = this;
      vm.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;

      if (vm.query.pageid) vm.pageid = vm.query.pageid;
    }
  },
  computed: {
    view() {
      return this.query.view;
    }
  }
};
</script>

<style>
.mybtn {
  background-image: linear-gradient(160deg, #3fd8e7e1 0%, #1ba6c9d8 74%);
  margin-bottom: 50px;
  color: white !important;
}
* {
  font-family: "Sarabun";
}
</style>